import cls from "@fvilers/cls";
import { ComponentPropsWithoutRef } from "react";
import { useFieldContext } from "../../hooks/useAppForm";
import { TabsProvider } from "./context/TabsProvider";
import styles from "./Tabs.module.css";

export type TabsProps<T extends React.ElementType> = {
  as?: T;
  className?: string;
  defaultTab?: string;
  onTabChange?: (value: string) => void;
  unmount?: boolean;
  value?: string;
} & ComponentPropsWithoutRef<T>;

export function Tabs<T extends React.ElementType>({
  as,
  className,
  defaultTab,
  onBlur,
  onTabChange,
  unmount,
  value,
  ...props
}: TabsProps<T>) {
  const Comp = as || "div";

  return (
    <TabsProvider
      defaultTab={defaultTab}
      onBlur={onBlur}
      onTabChange={(value) => {
        onTabChange?.(value);
      }}
      unmount={unmount}
      value={value}
    >
      <Comp className={cls(styles.Tabs, className)} {...props} />
    </TabsProvider>
  );
}

export function TabsField<T extends React.ElementType>(props: TabsProps<T>) {
  const field = useFieldContext<string>();
  return (
    <Tabs
      {...props}
      onBlur={field.handleBlur}
      onTabChange={field.handleChange}
      value={field.state.value}
    />
  );
}
